import React, { useState, useRef } from 'react';
import { TbMailForward } from 'react-icons/tb';
import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';

function ContactForm() {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ email: false, required: false });

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSendMail = async (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const name = formData.get('from_name');
    const email = formData.get('from_email');
    const message = formData.get('message');

    if (!name || !email || !message) {
      setError({ ...error, required: true });
      return;
    }

    if (!isValidEmail(email)) {
      setError({ ...error, email: true });
      return;
    }

    try {
      setIsLoading(true);
      await emailjs.sendForm(
        'service_g0ko73d',
        'template_qq43csh',
        form.current,
        'i4wWuhkl1Vu-z_ktm'
      );
      toast.success('Message sent successfully!');
      form.current.reset();
      setError({ email: false, required: false });
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const inputClass = `w-full rounded-xl px-4 py-3 text-sm outline-none transition-all duration-200
    dark:bg-slate-800/50 bg-white
    dark:border border dark:border-slate-600/50 border-slate-200
    dark:text-slate-200 text-slate-800
    dark:placeholder-slate-500 placeholder-slate-400
    focus:border-blue-500 dark:focus:border-blue-400
    focus:ring-2 focus:ring-blue-500/20`;

  return (
    <form ref={form} onSubmit={handleSendMail} className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium dark:text-slate-300 text-slate-700">Your Name</label>
        <input name="from_name" type="text" placeholder="Santiago Ornelas" className={inputClass} required />
      </div>

      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium dark:text-slate-300 text-slate-700">Email Address</label>
        <input name="from_email" type="email" placeholder="hello@example.com" className={inputClass} required />
      </div>

      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium dark:text-slate-300 text-slate-700">Subject</label>
        <input name="subject" type="text" placeholder="What's this about?" className={inputClass} />
      </div>

      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium dark:text-slate-300 text-slate-700">Message</label>
        <textarea
          name="message"
          rows="5"
          placeholder="Tell me about your project, opportunity, or just say hi..."
          className={`${inputClass} resize-none`}
          required
        />
      </div>

      {error.required && (
        <p className="text-sm text-red-400">All fields are required.</p>
      )}
      {error.email && (
        <p className="text-sm text-red-400">Please enter a valid email address.</p>
      )}

      <button
        type="submit"
        disabled={isLoading}
        className="flex items-center justify-center gap-2 rounded-full
          bg-gradient-to-r from-blue-500 to-purple-600
          text-white text-sm font-medium px-8 py-3
          hover:shadow-lg hover:shadow-blue-500/25 hover:scale-105
          disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100
          transition-all duration-200"
      >
        {isLoading ? 'Sending...' : <><span>Send Message</span> <TbMailForward size={18} /></>}
      </button>
    </form>
  );
}

export default ContactForm;
